export enum CourtSystemEntityAuditLogView {
  AdminUserAuditLog,
  UserGroupAuditLog,
  BillingGroupAuditLog,
  CaseAuditLog,
  HearingAuditLog,
  CourthouseAuditLog,
  DeletionAuditLog,
  DepartmentAuditLog,
  CourtroomAuditLog,
  JudgeAuditLog,
  RecordingAuditLog,
  RecorderAuditLog,
  RestApiKeyAuditLog,
}
